import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Adapter: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m510 750c-60.1 0-116.6-23.4-159.1-65.9s-65.9-99-65.9-159.1 23.4-116.6 65.9-159.1 99-65.9 159.1-65.9 116.6 23.4 159.1 65.9 65.9 99 65.9 159.1-23.4 116.6-65.9 159.1-99 65.9-159.1 65.9zm0-420c-107.52 0-195 87.48-195 195s87.48 195 195 195 195-87.48 195-195-87.48-195-195-195z' />
    <path d='m195 300c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m345 300c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <circle cx='432.5' cy='520' r='25' />
    <circle cx='587.5' cy='520' r='25' />
    <path d='m266.07 449.95c-105.72-2.1-191.07-88.74-191.07-194.95s87.48-195 195-195 195 87.48 195 195c0 6.31-.31 12.54-.9 18.7 9.97-1.82 20.11-2.98 30.38-3.45.34-5.05.52-10.14.52-15.25 0-60.1-23.4-116.6-65.9-159.1s-99-65.9-159.1-65.9-116.6 23.4-159.1 65.9-65.9 99-65.9 159.1 23.4 116.6 65.9 159.1c39.8 39.8 91.87 62.85 147.69 65.62 1.82-10.12 4.32-20.06 7.48-29.77z' />
  </IconBase>
));

Adapter.displayName = 'Adapter';

export default Adapter;
